import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type EmberStore from "cc-frontend/services/ember-store"
import type RotationEditor from "cc-frontend/services/rotation-editor"

interface Args {
  rotationCalendar: RotationCalendar
  courses: Array<Course>
  planbook: Planbook
  closeMenu: Function
  dateString: string
}

export default class DayMenuChangeSchooolYearDates extends Component<Args> {
  // state
  daysAfterStartDate = 0

  //services
  @service("ember-store") store!: EmberStore
  @service rotationEditor!: RotationEditor

  get menuName() {
    let semester = this.args.rotationCalendar.attributes.semesters[0]
    if (dateFns.differenceInDays(this.args.dateString, semester.startDate) > 365) {
      this.daysAfterStartDate = dateFns.differenceInDays(this.args.dateString, semester.startDate)
      return "ALERT_TOO_LONG"
    } else {
      return "CONFIRM"
    }
  }

  @action
  changeEndOfSchoolYear() {
    this.args.closeMenu()
    this.rotationEditor.changeSchoolYearDates({
      courses: this.args.courses,
      planbook: this.args.planbook,
      rotationCalendar: this.args.rotationCalendar,
      dateString: this.args.dateString,
      startOrEnd: "END",
    })
  }
}
